export interface TraceTypeOption {
  label: string;
  value: string;
}

export const TRACE_TYPE_OPTIONS: TraceTypeOption[] = [
  // OCPP WebSocket
  { label: 'WebSocket Authentication', value: 'fr.iolabs.rechargeplus.ocpp.model.WebsocketAuthentication' },
  { label: 'WebSocket New Session Start', value: 'fr.iolabs.rechargeplus.ocpp.model.WebsocketNewSessionStart' },
  // OCPP Core messages
  { label: 'Boot Notification', value: 'eu.chargetime.ocpp.model.core.BootNotification' },
  { label: 'Status Notification', value: 'eu.chargetime.ocpp.model.core.StatusNotification' },
  //{ label: 'Heartbeat', value: 'eu.chargetime.ocpp.model.core.Heartbeat' },
  { label: 'Authorize', value: 'eu.chargetime.ocpp.model.core.Authorize' },
  { label: 'Start Transaction', value: 'eu.chargetime.ocpp.model.core.StartTransaction' },
  { label: 'Stop Transaction', value: 'eu.chargetime.ocpp.model.core.StopTransaction' },
  { label: 'Meter Values', value: 'eu.chargetime.ocpp.model.core.MeterValues' },
  { label: 'Remote Start Transaction', value: 'eu.chargetime.ocpp.model.core.RemoteStartTransaction' },
  { label: 'Remote Stop Transaction', value: 'eu.chargetime.ocpp.model.core.RemoteStopTransaction' },
  { label: 'Change Availability', value: 'eu.chargetime.ocpp.model.core.ChangeAvailability' },
  { label: 'Change Configuration', value: 'eu.chargetime.ocpp.model.core.ChangeConfiguration' },
  { label: 'Get Configuration', value: 'eu.chargetime.ocpp.model.core.GetConfiguration' },
  { label: 'Clear Cache', value: 'eu.chargetime.ocpp.model.core.ClearCache' },
  { label: 'Reset', value: 'eu.chargetime.ocpp.model.core.Reset' },
  { label: 'Unlock Connector', value: 'eu.chargetime.ocpp.model.core.UnlockConnector' },
  { label: 'Get Diagnostics', value: 'eu.chargetime.ocpp.model.core.GetDiagnostics' },
  { label: 'Trigger Message', value: 'eu.chargetime.ocpp.model.core.TriggerMessage' },
  { label: 'Reserve Now', value: 'eu.chargetime.ocpp.model.core.ReserveNow' },
  { label: 'Cancel Reservation', value: 'eu.chargetime.ocpp.model.core.CancelReservation' },
  { label: 'Data Transfer', value: 'eu.chargetime.ocpp.model.core.DataTransfer' },
  // OCPP Firmware Management
  { label: 'Diagnostics Status Notification', value: 'eu.chargetime.ocpp.model.firmware.DiagnosticsStatusNotification' },
  { label: 'Firmware Status Notification', value: 'eu.chargetime.ocpp.model.firmware.FirmwareStatusNotification' },
  // Okecharge
  { label: 'Status Received (Okecharge)', value: 'StatusReceived' },
];

